export const FACTORY_INTEREST = 'factory_interest';
export const ABANDONED_CART = 'abandoned_cart';
